import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/*
 * Copyright (c) 2023 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @author Woonggi Kim
 * @contact wgkim@detech.co.kr
 * @date 2024-02-26
 * @brief 공통 confirm 팝업
 *
 ********************************************************************/
import React from "react";
//recoil
import { useRecoilState } from "recoil";
import { confirmState, } from "../../../recoil/assessmentState";
import * as CUTIL from "../../../utils/commUtils";
export default function CmmConfirmPop2(props) {
    const [confirm, setConfrim] = useRecoilState(confirmState);
    function Close(id) {
        if (confirm.leftBtnCallBack != null) {
            confirm.leftBtnCallBack();
            CUTIL.jsclose_Popup(id);
        }
        else {
            CUTIL.jsclose_Popup(id);
        }
    }
    function customBtnAction() {
        if (confirm.rightBtnCallBack != null) {
            confirm.rightBtnCallBack();
            if (confirm.layerId.length > 0) {
                CUTIL.jsclose_InPopup("pop-cmmConfirm1");
            }
            else {
                CUTIL.jsclose_Popup("pop-cmmConfirm1");
            }
        }
        else {
            CUTIL.jsclose_Popup("pop-cmmConfirm1");
        }
    }
    return (_jsx(_Fragment, { children: _jsxs("div", Object.assign({ id: "pop-cmmConfirm1", className: "popup-layer js-layer hidden popup-basic" }, { children: [_jsxs("div", Object.assign({ className: "popup__head" }, { children: [_jsx("h1", { children: confirm.header }), _jsx("button", Object.assign({ className: "btn btn-close js-close", onClick: (e) => CUTIL.jsclose_Popup("pop-cmmConfirm1") }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uB2EB\uAE30" })) }))] })), _jsx("div", Object.assign({ className: "popup__body" }, { children: _jsx("p", { children: confirm.content.split('\n').map((line, index) => (_jsxs(React.Fragment, { children: [line, index !== confirm.content.split('\n').length - 1 && _jsx("br", {})] }, index))) }) })), _jsxs("div", Object.assign({ className: "popup__footer" }, { children: [_jsx("button", Object.assign({ type: "button", className: "bg-gray js-close", onClick: (e) => Close("pop-cmmConfirm1") }, { children: _jsx("span", { children: confirm.leftBtnName }) })), _jsx("button", Object.assign({ type: "button", className: "js-close", onClick: (e) => customBtnAction() }, { children: _jsx("span", { children: confirm.rightBtnName }) }))] }))] })) }));
}
